import React from 'react';
import {Button, Collaboration} from 'components';
import {find, useNamedSelector, openPopup, over, preventDefault} from 'helpers';
import {store} from 'store';
import {role} from 'store/relations';

export function ShareButton({ id, context, collaborator }) {
  const { premium } = useNamedSelector('session.subscription');
  const collaboration = useNamedSelector('relations.collaboration', { id, context });
  const relation = find(collaboration?.relations, { email: collaborator.email });
  const shareable = premium && !collaboration || collaboration.shareable;
  const mode = !shareable ? 'disabled' : relation ? 'edit' : 'new';
  const share = () => store.dispatch({
    type: 'RELATIONS_SHARE',
    id,
    context,
    collaborator,
    shareType: 'Share'
  });
  const edit = openPopup(Collaboration.CollaborationMenu, {
    id,
    domain: context,
    collaborator,
  });
  return (
    <Button rightIcon={mode == 'edit' && 'chevron'} className={['tiny', mode != 'disabled' && 'primary']} onClick={over(mode == 'edit' ? edit : share, preventDefault)} disabled={mode == 'disabled'}>
      { role(relation) || 'Share' }
    </Button>
  );
}
